const PROXY_PFAD = '/apps/wishlist';
const LOGIN_PFAD = '/customer_authentication/login';

class SlWishlistButton extends HTMLElement {
  connectedCallback() {
    this.variante = this.dataset.variant || 'card';
    this.wishlistUrl = this.dataset.wishlistUrl || '/pages/wishlist';
    this.bind();
  }

  bind() {
    this.button = this.querySelector('button.sl-wishlist__btn');
    if (this.button && !this.gebunden) {
      this.gebunden = true;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.umschalten();
      });
    }
  }

  get eingeloggt() {
    return this.dataset.loggedIn === 'true';
  }

  get produktId() {
    return this.dataset.productId;
  }

  get gemerkt() {
    return this.button ? this.button.getAttribute('aria-pressed') === 'true' : true;
  }

  set gemerkt(wert) {
    if (!this.button) return;
    this.button.setAttribute('aria-pressed', wert ? 'true' : 'false');
    const text = wert ? this.dataset.labelRemove : this.dataset.labelAdd;
    this.button.setAttribute('aria-label', text);
    const label = this.querySelector('.sl-wishlist__label');
    if (label) label.textContent = text;
  }

  zumLogin() {
    wlPendingMerken(this.produktId);
    const zurueck = window.location.pathname + window.location.search;
    window.location.href = `${LOGIN_PFAD}?return_to=${encodeURIComponent(zurueck)}`;
  }

  zuLinkUmwandeln() {
    const text = this.dataset.labelView;
    this.innerHTML =
      `<a class="sl-wishlist__btn sl-wishlist__link" href="${this.wishlistUrl}" aria-label="${text}">` +
      '<svg class="sl-wishlist__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 20.7 3.9 12.6a5.1 5.1 0 0 1 7.2-7.2l.9.9.9-.9a5.1 5.1 0 0 1 7.2 7.2z" /></svg>' +
      `<span class="sl-wishlist__label">${text}</span></a>`;
    this.classList.add('is-saved');
    this.button = null;
  }

  async umschalten() {
    if (!this.eingeloggt) {
      this.zumLogin();
      return;
    }
    if (this.laeuft) return;
    this.laeuft = true;

    const istPdp = this.variante === 'pdp';
    const hinzufuegen = istPdp ? true : !this.gemerkt;
    if (!istPdp) this.gemerkt = hinzufuegen;
    this.button.disabled = true;

    try {
      const aktion = hinzufuegen ? 'add' : 'remove';
      const url = `${PROXY_PFAD}?action=${aktion}&product_id=${encodeURIComponent(this.produktId)}`;
      const antwort = await fetch(url, { method: 'POST', headers: { Accept: 'application/json' } });

      if (antwort.status === 403) {
        this.zumLogin();
        return;
      }
      if (!antwort.ok) throw new Error(`HTTP ${antwort.status}`);

      const daten = await antwort.json();
      if (!daten.ok) throw new Error(daten.fehler || 'Unbekannter Fehler');

      if (istPdp && hinzufuegen) {
        this.zuLinkUmwandeln();
      }

      document.dispatchEvent(
        new CustomEvent('sl:wishlist:changed', {
          detail: { anzahl: daten.anzahl, wishlist: daten.wishlist, produktId: this.produktId },
        })
      );
    } catch (fehler) {
      if (!istPdp) this.gemerkt = !hinzufuegen;
      console.error('[Wunschliste]', fehler);
    } finally {
      this.laeuft = false;
      if (this.button) this.button.disabled = false;
    }
  }
}

if (!customElements.get('sl-wishlist-button')) {
  customElements.define('sl-wishlist-button', SlWishlistButton);
}


/* --- Hydration: gemerkten Status beim Laden setzen (unabhängig vom Server-Render/Cache) --- */
const WL_CACHE = 'sl_wl_ids';
function wlCacheLesen() { try { const r = sessionStorage.getItem(WL_CACHE); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
function wlCacheSetzen(ids) { try { sessionStorage.setItem(WL_CACHE, JSON.stringify(ids || [])); } catch (e) {} }
function wlHydrieren(ids) {
  const gesetzt = new Set((ids || []).map(String));
  document.querySelectorAll('sl-wishlist-button').forEach((el) => {
    if (!gesetzt.has(String(el.dataset.productId))) return;
    if (el.dataset.variant === 'pdp') {
      if (el.querySelector('button.sl-wishlist__btn') && typeof el.zuLinkUmwandeln === 'function') el.zuLinkUmwandeln();
    } else if (el.querySelector('button.sl-wishlist__btn')) {
      el.classList.add('is-saved');
      el.gemerkt = true;
    }
  });
}
async function wlLaden() {
  try {
    const antwort = await fetch(`${PROXY_PFAD}?action=list`, { method: 'POST', headers: { Accept: 'application/json' } });
    if (!antwort.ok) { wlCacheSetzen([]); return []; }
    const daten = await antwort.json();
    const ids = daten && daten.ids ? daten.ids.map(String) : [];
    wlCacheSetzen(ids);
    return ids;
  } catch (e) { return null; }
}
/* Gast klickt aufs Herz -> wird zum Login geschickt -> nach dem Login muss das
   Produkt nachtraeglich gemerkt werden. Fruehere Fassung hielt nur EIN Produkt
   und loeschte es VOR dem Serveraufruf: schlug der fehl (z. B. 403, weil noch
   nicht eingeloggt), war der Merkwunsch endgueltig weg. Jetzt: Liste, und
   loeschen erst nach bestaetigtem Erfolg. */
const WL_PENDING = 'sl_wl_pending';
const WL_PENDING_MAX_ALTER = 7 * 24 * 60 * 60 * 1000;

function wlPendingLesen() {
  try {
    const roh = localStorage.getItem(WL_PENDING);
    if (!roh) return [];
    if (roh.charAt(0) !== '[') return [{ id: roh, ts: Date.now() }]; // Altformat: nackte ID
    const liste = JSON.parse(roh);
    return Array.isArray(liste) ? liste.filter((e) => e && e.id) : [];
  } catch (e) { return []; }
}

function wlPendingSchreiben(liste) {
  try {
    if (!liste || !liste.length) localStorage.removeItem(WL_PENDING);
    else localStorage.setItem(WL_PENDING, JSON.stringify(liste));
  } catch (e) {}
}

function wlPendingMerken(produktId) {
  if (!produktId) return;
  const liste = wlPendingLesen().filter((e) => String(e.id) !== String(produktId));
  liste.push({ id: String(produktId), ts: Date.now() });
  wlPendingSchreiben(liste);
}

async function wlPendingAbarbeiten() {
  const offen = wlPendingLesen();
  if (!offen.length) return false;
  const jetzt = Date.now();
  const frisch = offen.filter((e) => !e.ts || jetzt - e.ts < WL_PENDING_MAX_ALTER);
  const rest = [];
  let letzteListe = null;
  let erfolg = false;

  for (const eintrag of frisch) {
    try {
      const url = `${PROXY_PFAD}?action=add&product_id=${encodeURIComponent(eintrag.id)}`;
      const antwort = await fetch(url, { method: 'POST', headers: { Accept: 'application/json' } });
      if (!antwort.ok) { rest.push(eintrag); continue; }   // 403 = noch Gast -> aufheben
      const daten = await antwort.json();
      if (!daten || !daten.ok) { rest.push(eintrag); continue; }
      letzteListe = daten.wishlist || letzteListe;
      erfolg = true;
    } catch (e) {
      rest.push(eintrag);
    }
  }

  wlPendingSchreiben(rest);
  if (letzteListe) wlCacheSetzen(letzteListe.map((g) => String(g).split('/').pop()));
  return erfolg;
}
const WL_RELOAD_FLAG = 'sl_wl_nachgeladen';

async function wlInit() {
  const nachgetragen = await wlPendingAbarbeiten();
  /* Die Wunschlistenseite wird serverseitig gerendert. Wurde das Produkt erst
     eben nachgetragen, steht es noch nicht im HTML - einmal neu laden. Das Flag
     verhindert eine Schleife, falls der Nachtrag nicht sichtbar wird. */
  if (nachgetragen && document.querySelector('[data-sl-wishlist-page]')) {
    let schonMal = null;
    try { schonMal = sessionStorage.getItem(WL_RELOAD_FLAG); } catch (e) {}
    if (!schonMal) {
      try { sessionStorage.setItem(WL_RELOAD_FLAG, '1'); } catch (e) {}
      window.location.reload();
      return;
    }
  }
  if (!nachgetragen) { try { sessionStorage.removeItem(WL_RELOAD_FLAG); } catch (e) {} }
  const cache = wlCacheLesen();
  if (cache) { wlHydrieren(cache); } else { const ids = await wlLaden(); if (ids) wlHydrieren(ids); }
}
document.addEventListener('sl:wishlist:changed', (e) => {
  const wl = (e.detail && e.detail.wishlist) || [];
  wlCacheSetzen(wl.map((g) => String(g).split('/').pop()));
});
if (document.readyState !== 'loading') wlInit();
else document.addEventListener('DOMContentLoaded', wlInit);
